module.exports = __webpack_public_path__ + "static/18-cd2d9666e1de542f48c36c8b3b336459.jpeg";